export interface LowCarbonFuel {
    id: string;
    fuelName: LowCarbonFuels;
  }
  export enum LowCarbonFuels {
    LBG = 'LBG',
    LSM = 'LSM',
  }
  